import { ChevronUp } from 'react-feather';
import styles from './styles/BackToTop.module.scss';

interface IProps {
  className?: string;
  onClick(): void;
}

const BackToTop = ({ className, onClick }: IProps) => (
  <div className={classnames(styles.backToTop, className)}>
    <span onClick={onClick}>
      Back to the top
      <ChevronUp className={styles.chevron} size={16} />
    </span>
  </div>
);

export default BackToTop;
